"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormstateX = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var Form_1 = require("../Form");
exports.default = mobx_react_1.observer(function Form(_a) {
    var _this = this;
    var state = _a.state, onSubmit = _a.onSubmit, formProps = tslib_1.__rest(_a, ["state", "onSubmit"]);
    var handleSubmit = react_1.useCallback(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var validated;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, state.validate()];
                case 1:
                    validated = _a.sent();
                    if (validated.hasError)
                        return [2 /*return*/];
                    return [2 /*return*/, onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(validated.value)];
            }
        });
    }); }, [state, onSubmit]);
    return (react_1.default.createElement(Form_1.Form, tslib_1.__assign({}, formProps, { onSubmit: handleSubmit })));
});
/**
 * 在 React 组件中构造 `FormState` / `FieldState` 实例的 hooks
 *
 * 使用姿势：
 * function createState(foo: Foo, bar?: Bar) {
 *  return new FormState({
 *    foo: new FieldState(foo)
 *    bar: new FieldState(bar)
 *  })
 * }
 *
 * function Comp({ foo, bar }) {
 *  const state = useFormstateX(createState, [foo, bar])
 * }
 * */
function useFormstateX(createState, parameters) {
    var _a = react_1.useState(function () { return createState.apply(void 0, parameters); }), state = _a[0], setState = _a[1];
    var isFirstRef = react_1.useRef(true);
    react_1.useEffect(function () {
        // 跳过第一次 render 后的 effect，避免 state 的重复构造与替换；
        // 此时 createState 未发生变更，render 时所构造的 state 依然可用
        if (isFirstRef.current) {
            isFirstRef.current = false;
            return;
        }
        setState(createState.apply(void 0, parameters));
    }, parameters); // eslint-disable-line react-hooks/exhaustive-deps
    react_1.useEffect(function () { return state.dispose; }, [state]);
    return state;
}
exports.useFormstateX = useFormstateX;
//# sourceMappingURL=Form.js.map